module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/event-badge-a32018c36a538579af1bf66ba08e6a3c.svg";